import routerOptions0 from "C:/Users/GraphiDev_U3/Documents/_CLIENTS/App/node_modules/.pnpm/nuxt@3.10.0_sass@1.70.0_vite@5.0.12/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}